import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	headerDescriptionJsm: {
		id: 'spa-apps-sidebar-servicedesk.common.header-description-jsm',
		defaultMessage: 'Service project',
		description: 'Project type description in a service-desk project.',
	},
	gettingStarted: {
		id: 'spa-apps-sidebar-servicedesk.common.getting-started',
		defaultMessage: 'Get started',
		description: 'Navigation item which links to getting started page',
	},
	itemQueuesRetranslate: {
		id: 'spa-apps-sidebar-servicedesk.common.item-queues-retranslate',
		defaultMessage: 'Queues',
		description: 'Navigation item which links to queues view',
	},
	itemProjectSummary: {
		id: 'spa-apps-sidebar-servicedesk.common.item-project-summary.non-final',
		defaultMessage: 'Summary',
		description: 'Navigation item which links to jsm project summary',
	},
	itemViews: {
		id: 'spa-apps-sidebar-servicedesk.common.item-views',
		defaultMessage: 'Views',
		description: 'Navigation item which links to jsm views',
	},
	itemBoards: {
		id: 'spa-apps-sidebar-servicedesk.common.item-boards',
		defaultMessage: 'Board',
		description: 'Navigation item which links to jsm board',
	},
	itemCalendars: {
		id: 'spa-apps-sidebar-servicedesk.common.item-calendars',
		defaultMessage: 'Calendar',
		description: 'Navigation item which links to jsm calendar',
	},
	itemCustomers: {
		id: 'spa-apps-sidebar-servicedesk.common.item-customers',
		defaultMessage: 'Customers',
		description: 'Navigation item which links to customers page',
	},
	itemReports: {
		id: 'spa-apps-sidebar-servicedesk.common.item-reports',
		defaultMessage: 'Reports',
		description: 'Navigation item which links to reports view',
	},
	itemRaiseRequest: {
		id: 'spa-apps-sidebar-servicedesk.common.item-raise-request',
		defaultMessage: 'Raise a request',
		description: 'Navigation item which links to raise a request',
	},
	itemCustomerChannels: {
		id: 'spa-apps-sidebar-servicedesk.common.item-customer-channels',
		defaultMessage: 'Channels',
		description: 'Navigation item which opens the customer channels inline dialog',
	},
	itemInviteAgents: {
		id: 'spa-apps-sidebar-servicedesk.common.item-invite-agents',
		defaultMessage: 'Invite agents',
		description: 'Navigation item which opens invite agents modal',
	},
	itemAddPeople: {
		id: 'spa-apps-sidebar-servicedesk.common.item-add-people',
		defaultMessage: 'Add people',
		description:
			'Navigation item which opens core invites modal, the modal has options to invite different kinds of users in the project.',
	},
	itemInsight: {
		id: 'spa-apps-sidebar-servicedesk.common.item-insight',
		defaultMessage: 'Insight',
		description: 'Navigation item which links to CMDB page in service project',
	},
	itemCmdbAssets: {
		id: 'spa-apps-sidebar-servicedesk.common.item-cmdb-assets',
		defaultMessage: 'Assets',
		description: 'Navigation item which links to CMDB page in service project',
	},
	projectSettingsRetranslate: {
		id: 'spa-apps-sidebar-servicedesk.common.project-settings-retranslate',
		defaultMessage: 'Project settings',
		description: 'Navigation item which links to settings page in service project',
	},
	serviceProjectSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.service-project-settings',
		defaultMessage: 'Project settings',
		description: 'Navigation item which links to a project settings page',
	},
	serviceHubSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.service-hub-settings',
		defaultMessage: 'Service hub settings',
		description: 'Navigation item which links to a service hub settings page',
	},
	customerHubSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.customer-hub-settings',
		defaultMessage: 'Customer hub settings',
		description: 'Navigation item which links to a customer hub settings page',
	},
	itemIssues: {
		id: 'spa-apps-sidebar-servicedesk.common.item-issues',
		defaultMessage: 'Issues and filters',
		description: 'Navigation item which links from or to an issues page',
	},
	backToProject: {
		id: 'spa-apps-sidebar-servicedesk.common.back-to-project',
		defaultMessage: 'Back to project',
		description: 'Back to project link item',
	},
	backToServiceProject: {
		id: 'spa-apps-sidebar-servicedesk.common.back-to-service-project',
		defaultMessage: 'Back to service project',
		description: 'Back to service project link item',
	},
	navigateToIncidents: {
		id: 'spa-apps-sidebar-servicedesk.common.navigate-to-incidents',
		defaultMessage: 'navigate to incident queues',
		description:
			'Label for the arrow icon which shows when mouse hover on incidents navigation item',
	},
	learnMore: {
		id: 'spa-apps-sidebar-servicedesk.common.learn-more',
		defaultMessage: 'Learn more',
		description:
			'Title for "learn more" link pointing to the page with helpful information about the project type',
	},
	learnMoreAriaLabel: {
		id: 'spa-apps-sidebar-servicedesk.common.learn-more-aria-label',
		defaultMessage: 'Learn more about Jira Service Management team-managed projects',
		description:
			'Title for "learn more" link pointing to the page with helpful information about the project type',
	},
	getHelp: {
		id: 'spa-apps-sidebar-servicedesk.common.get-help',
		defaultMessage: 'Get help',
		description:
			'Title for "Get help" link pointing to the page with helpful information about the project type',
	},
	feedback: {
		id: 'spa-apps-sidebar-servicedesk.common.feedback',
		defaultMessage: 'Give feedback',
		description: 'Link that opens the feedback dialog',
	},
	services: {
		id: 'spa-apps-sidebar-servicedesk.common.services',
		defaultMessage: 'Services',
		description:
			'Navigation item which brings the navigation back to service project service registry page',
	},
	directory: {
		id: 'spa-apps-sidebar-servicedesk.common.directory',
		defaultMessage: 'Directory',
		description:
			'Heading for navigation section containing links to customer and team support pages',
	},
	knowledgeInsights: {
		id: 'spa-apps-sidebar-servicedesk.common.knowledge-insights',
		defaultMessage: 'Knowledge',
		description: 'Heading for navigation section containing links to knowledge bases and reports',
	},
	operations: {
		id: 'spa-apps-sidebar-servicedesk.common.operations',
		defaultMessage: 'Operations',
		description: 'Heading for navigation section containing links to operations management',
	},
	alerts: {
		id: 'spa-apps-sidebar-servicedesk.common.alerts',
		defaultMessage: 'Alerts',
		description: 'Link that opens the incident alerts page',
	},
	linkOpensInNewWindow: {
		id: 'spa-apps-sidebar-servicedesk.common.link-opens-in-new-window',
		defaultMessage: 'Link opens in a new window',
		description:
			'Visually hidden text to indicate that link opens in a new window for users who uses screen reader',
	},
	onCall: {
		id: 'spa-apps-sidebar-servicedesk.common.on-call',
		defaultMessage: 'On-call',
		description: 'Link that opens the on-call schedules page',
	},
	shortcuts: {
		id: 'spa-apps-sidebar-servicedesk.common.shortcuts',
		defaultMessage: 'Shortcuts',
		description: 'Heading for navigation section containing user created shortcuts',
	},
	addShortcutLabel: {
		id: 'spa-apps-sidebar-servicedesk.common.add-shortcut-label',
		defaultMessage: 'Add shortcut',
		description: 'Label for the nav item to add shortcuts',
	},
	changeCalendar: {
		id: 'spa-apps-sidebar-servicedesk.common.change-calendar',
		defaultMessage: 'Change calendar',
		description:
			'Label for the nav item which opens the change calendar, showing change requests. This is NOT relating to changing a calendar, and probably shouldn\'t be translated with the verb "to change".',
	},
	newLozenge: {
		id: 'spa-apps-sidebar-servicedesk.common.new-lozenge',
		defaultMessage: 'New',
		description:
			'Small lozenge that appears to the right of the nav item, indicating a new feature.',
	},
	itemOrganizations: {
		id: 'spa-apps-sidebar-servicedesk.common.item-organizations',
		defaultMessage: 'Organizations',
		description: 'Navigation item which links to organizations page',
	},
	itemIndividuals: {
		id: 'spa-apps-sidebar-servicedesk.common.item-individuals',
		defaultMessage: 'Customers',
		description: 'Navigation item which links to individuals page',
	},
	itemProducts: {
		id: 'spa-apps-sidebar-servicedesk.common.item-products',
		defaultMessage: 'Products',
		description: 'Navigation item which links to products page',
	},
	itemDeveloperEscalations: {
		id: 'spa-apps-sidebar-servicedesk.common.item-developer-escalations',
		defaultMessage: 'Developer escalations',
		description: 'Navigation item which links to developer escalations page',
	},

	notificationLogs: {
		id: 'spa-apps-sidebar-servicedesk.common.item-notification-logs',
		defaultMessage: 'Customer notification logs',
		description: 'Navigation item which links to Customer notification logs',
	},
	sideBarNavigationTitle: {
		id: 'spa-apps-sidebar-servicedesk.menu.section-with-header.side-bar-navigation-title',
		defaultMessage: 'Menu',
		description: 'Hidden Sidebar navigation menu title for screen reader',
	},
	itemArchives: {
		id: 'spa-apps-sidebar-servicedesk.menu.item-archives',
		defaultMessage: 'Archived issues',
		description: '"Archived issues" menu item.',
	},
});
